export default {
  uploadImageLink: {
    id: 'STORY_LOGO_UPLOAD_IMAGE_LINK',
    defaultMessage: 'Upload logo',
    description: 'Select Story  > See the logo section > see the link',
  },
};
